import React, { useEffect } from 'react';
import {
  useQuery,
  useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

export const useSpedQuery = ({
  queryName, queryKeys, url, body, queryOptions,
  onFirstSuccess, select, errorMessage} ) => {

  const firstSuccess = React.useRef(false);

  const fetcherFn = async () => {
    // figure out how we are sending payload and add paging params to it
    if (body !== undefined) {
      // POST
      const { data } = await postBody({
        url: url.toString(),
        body,
      });
      return data;

    } else {
      // GET
      const { data } = await axios(url.toString());
      return data;
    }
  };

  const queryClient = useQueryClient();
  const queryNameKeys =  getQueryKey(queryName, queryKeys);
  const query = useQuery({
    queryKey: queryNameKeys,
    queryFn: fetcherFn,
    select: select,
    ...queryOptions
  });

  React.useEffect(() => {
    if (onFirstSuccess && !firstSuccess.current) {
      if (query.isSuccess && !query.isRefetching) {
        firstSuccess.current = true;
        onFirstSuccess(query);
      }
    }
  }); // No dependencies, we want this at each render

  // common error handling - if error and message supplied will be displayed in error toast
  useEffect(() => {
    if (errorMessage && query.isError) {
      console.log('errormessage:', errorMessage)
//      showError(errorMessage);
    }
  }, [ // eslint-disable-line react-hooks/exhaustive-deps
    query.isError,
    errorMessage
  ]);

  return {
    ...query,
    invalidate: () => queryClient.invalidateQueries({
      queryKey: queryName
    }),
    firstSuccess: firstSuccess.current || (query.isSuccess && !query.isRefetching),
  };
};

export const postBody = ({ url, body, multipart = false }) => {
  const contentType = (multipart) ? 'multipart/form-data' : 'application/json';
  return axios.post(url.toString(), body,
    {
      headers: {
        'Content-Type': contentType,
      }
    });
};

/** Merges queryName and queryKeys into one array */
export const getQueryKey = (queryName, queryKeys) => {
  if (Array.isArray(queryKeys)) {
    return [queryName, ...queryKeys];
  }

  return queryKeys ? [queryName, queryKeys] : [queryName];
};
